import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card__header" }
const _hoisted_2 = { class: "card__header__info" }
const _hoisted_3 = { class: "card__header__info--number" }
const _hoisted_4 = {
  key: 0,
  class: "card__body"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

import chartIcon from "@/assets/images/chart.png";
import errorChartIcon from "@/assets/images/chart-error.png";

interface Icard {
  label: string;
  number: number;
  status?: "less" | "more";
  size?: "small" | "large";
  bg?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomCard',
  props: {
    label: { default: "" },
    number: {},
    status: { default: "less" },
    size: { default: "small" },
    bg: { default: "" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-cu-card", [__props.size, __props.status]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "card__header__info--label",
          style: _normalizeStyle(__props.bg ? { backgroundColor: `var(${__props.bg})` } : {})
        }, _toDisplayString(__props.label), 5),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.number), 1)
      ])
    ]),
    (__props.size === 'large')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (__props.status === 'more')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(chartIcon),
                alt: "chart"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _unref(errorChartIcon),
                alt: "chart-error"
              }, null, 8, _hoisted_6))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})